import { app } from '../../../../app';

app.factory('NewSmsNumber', NewSmsNumber);

/** @ngInject */
function NewSmsNumber($resource) {
    return $resource('app/rest/phonenumbers/:id/setSmsNumber', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/new-sms-number.service.js